module.exports = __webpack_public_path__ + "static/img/bg__signup(old).ba38a8a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/archive/bg__signup(old).png
// module id = 7em3
// module chunks = 1